<mat-progress-bar mode="determinate" [value]="percentRemaining">
</mat-progress-bar>

<ng-container [ngSwitch]="data.type">
    <mat-icon *ngSwitchCase="types.SUCCESS" [svgIcon]="'success'"></mat-icon>
    <mat-icon *ngSwitchCase="types.WARNING" [svgIcon]="'warning'"></mat-icon>
    <mat-icon *ngSwitchCase="types.ERROR" [svgIcon]="'error'"></mat-icon>
</ng-container>

<span class="growler-text">
    <span class="growler-title">{{ data?.title }}</span>
    {{ data?.message }}
</span>

<button class="dismiss-growler" (click)="dismiss()" mat-button [disableRipple]="true">
    <mat-icon [svgIcon]="'close'"></mat-icon>
</button>
